module.exports = __webpack_public_path__ + "img/top.46ce44b4.gif";